// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__PjHIL","active":"styles_active__EoFsY"};